/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
author: cooper (https://sketchfab.com/cooper)
license: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
source: https://sketchfab.com/3d-models/akai-mpk-mini-f7a837c9b469472084940ab3d6609eb2
title: AKAI MPK Mini
*/

import { useGLTF } from '@react-three/drei';
import { useFrame } from "@react-three/fiber";
import React, { useRef } from 'react';
import { Vector3 } from 'three';
import { lerp } from 'three/src/math/MathUtils';
const vec = new Vector3()
export default function MidiKeyboardModel({ ...props }) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/akai_mpk_mini/scene.gltf')
  useFrame((state) => {
    const { clock, camera, mouse, size } = state
    const t = clock.getElapsedTime()
    camera.lookAt(0, 0, 0)
    camera.position.lerp(vec.set(0, 0, 840), 0.1)
    // console.log(size.height, mouse.y)
    group.current.rotation.x = lerp(group.current.rotation.x, -mouse.y * 0.2 + Math.cos(t / 2) / 8 + 0.25, 0.1)
    group.current.rotation.y = lerp(group.current.rotation.y, mouse.x * .5 + Math.sin(t / 4) / 4, 0.1)
    group.current.rotation.z = lerp(group.current.rotation.z, Math.sin(t / 4) / 4, 0.1)
    group.current.position.y = lerp(group.current.position.y, (-2 + Math.sin(t)) / 3, 0.1)

  })
  return (
    <group ref={group} {...props} dispose={null}>
      
      <group scale={0.6} position={[0, 0, 0]} rotation={[-Math.PI / 2, 0, 0]}>
        <group rotation={[Math.PI / 2, 0, 0]}>
          <group position={[128.35, 30.92, 32.63]} rotation={[-Math.PI / 2, 0, 0]}>
            <mesh geometry={nodes['AKAI_LP_03_-_Default_0'].geometry} material={materials['03_-_Default']} />
          </group>
        </group>
      </group>

    </group>
  )
}

useGLTF.preload('/akai_mpk_mini/scene.gltf')
